// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"logo-codepen"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M2.5 15.15L12 8.50002M12 8.50002L21.5 15.15M12 8.50002V2.75002M21.5 8.85002L12 15.5M12 15.5L2.5 8.85002M12 15.5V21.5M2 15.5V8.5L12 2L22 8.5V15.5L12 22L2 15.5Z","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LogoCodepenIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'logo-codepen',
    ref,
    icon: element,
  },
));

LogoCodepenIcon.displayName = 'LogoCodepenIcon';

export default LogoCodepenIcon;
